import React from "react";

export default function ToggleSwitch({
  isOn,
  onChange,
  disabled = false,
  size = "md",
}) {
  const sizes = {
    sm: {
      container: "w-8 h-4",
      circle: "w-3 h-3",
      translateX: "translate-x-4",
    },
    md: {
      container: "w-12 h-6",
      circle: "w-4 h-4",
      translateX: "translate-x-6",
    },
    lg: {
      container: "w-16 h-8",
      circle: "w-6 h-6",
      translateX: "translate-x-8",
    },
  };

  const handleToggle = () => {
    if (disabled) return;
    onChange?.(!isOn);
  };

  return (
    <div
      onClick={handleToggle}
      className={`${
        sizes[size].container
      } rounded-full p-1 transition-colors duration-300 ease-in-out ${
        isOn ? "bg-blue-500" : "bg-gray-300"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <div
        className={`bg-white ${
          sizes[size].circle
        } rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${
          isOn ? sizes[size].translateX : "translate-x-0"
        }`}
      ></div>
    </div>
  );
}
